<template>
  <div>
    <custom-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :titleObj="titleObj"
    ></custom-header>
    <custom-center></custom-center>
    <custom-footer :bottom="bottom" :bottomInfo="bottomInfo"></custom-footer>
  </div>
</template>

<script>
import CustomHeader from '@/components/mobile/Header'
import CustomCenter from '@/components/mobile/CustomCenter'
import CustomFooter from '@/components/mobile/Footer'
export default {
  name: 'custom',
  data() {
    return {
      actIndex: 1,
      topStyle: "",
      titleObj:{
        title: "软件研发",
        desc:
          "一匠提供应用软件开发与企业信息化建设服务，将IT与业务需求统一起来，能够帮助客户实现商业成功",
      },
      imgList: [],
      bottom: {},
      logo: '',
      bottomInfo: {},
      background: require("../../static/images/custom_mobile/banner.png"),
    }
  },
  components: {
    CustomHeader,
    CustomCenter,
    CustomFooter,
  },
  mounted() {
    this.Pc_Mobile()
    this.getPageData()
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push('/m_custom');
      } else {
        this.$router.push('/custom');
      }
    },
    getPageData() {
      this.$http.post('home/index/m_aboutpag', null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0]
        this.logo = this.bottom.logo
        this.topStyle = "background-image:url('" + this.background + "')"
        this.bottomInfo = res.data.contact[0]
      })
    }
  }
}
</script>

<style lang="stylus" scoped></style>


// WEBPACK FOOTER //
// src/views/mobile/Custom.vue